import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AdminLayout.css';

const AdminLayout = () => {
    const { t } = useTranslation();

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <h3>{t('admin_panel', 'Admin Panel')}</h3>
                <nav>
                    <ul>
                        <li><Link to="/admin">{t('dashboard', 'Dashboard')}</Link></li>
                        <li><Link to="/admin/users">{t('manage_users', 'Users & Profiles')}</Link></li>
                        <li><Link to="/admin/access-control">{t('access_control', 'Access Control')}</Link></li>
                        <li><Link to="/admin/verification">{t('verification_requests', 'Verification Requests')}</Link></li>
                        <li><Link to="/admin/email">{t('email_dispatch', 'Disparo de Email')}</Link></li>
                        <li><Link to="/">{t('back_to_site', 'Back to Site')}</Link></li>
                    </ul>
                </nav>
            </aside>
            <main className="admin-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
